'use client'
import { useState, type ReactNode } from 'react'
import dynamic from 'next/dynamic'
import type { CtaLocation } from '@/lib/analytics/events'

const BookingModal = dynamic(() => import(/* webpackChunkName: "booking-modal" */ './BookingModal'), { ssr: false })

export type BookingIntent = 'assessment' | 'online_quote'

type BookingTriggerProps = {
  children?: ReactNode
  intent?: BookingIntent
  ctaLocation?: CtaLocation
}

const DEFAULT_TRIGGER = <button className="btn btn-primary">Book Free Assessment</button>

export default function BookingTrigger({
  children,
  intent = 'assessment',
  ctaLocation = 'inline',
}: BookingTriggerProps) {
  const [opened, setOpened] = useState(false)
  const triggerNode = children ?? DEFAULT_TRIGGER

  if (!opened) {
    return (
      <div
        data-booking-trigger=""
        data-booking-intent={intent}
        data-cta-location={ctaLocation}
        onClick={() => setOpened(true)}
      >
        {triggerNode}
      </div>
    )
  }

  return <BookingModal intent={intent} initialOpen trigger={triggerNode} ctaLocation={ctaLocation} />
}
